import { render, staticRenderFns } from "./WorkflowTestTaskAuditTrail.vue?vue&type=template&id=1f799c20"
import script from "./WorkflowTestTaskAuditTrail.vue?vue&type=script&lang=js"
export * from "./WorkflowTestTaskAuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports